export const getIpawsFindingElementId = (fieldPath) => `ipaws-alert-${fieldPath}-findings`;

export const getIpawsFieldFindings = (fieldPath, findings = []) =>
  findings.filter((finding) => finding.fieldPath === fieldPath);

export const getIpawsFieldFindingDescriptionId = (fieldPath, findings = []) =>
  getIpawsFieldFindings(fieldPath, findings).length
    ? getIpawsFindingElementId(fieldPath)
    : undefined;

const IpawsFieldFindings = ({ fieldPath, findings = [] }) => {
  const fieldFindings = getIpawsFieldFindings(fieldPath, findings);
  if (!fieldFindings.length) return null;

  return (
    <ul id={getIpawsFindingElementId(fieldPath)} className="small alert-creator-finding mb-0 ps-3">
      {fieldFindings.map((finding) => (
        <li key={finding.message}>{finding.message}</li>
      ))}
    </ul>
  );
};

export default IpawsFieldFindings;
